module.exports = __webpack_public_path__ + "static/Lei2-b672b4d1cccfe2366085670306f6df8a.jpg";